import { put, takeEvery } from "redux-saga/effects";
import { fetchGraphMethod, fetchMethod } from "../../services/httpService";
import messagePopup from "../../utils/messagePopup";

// ========================================== Action Type =====================================================
export const actionType = {
    ACADEMIC_NOTES_LIST_START: "ACADEMIC_NOTES_LIST_START",
    ACADEMIC_NOTES_LIST_SUCCESS: "ACADEMIC_NOTES_LIST_SUCCESS",
    ACADEMIC_NOTES_LIST_FAILED: "ACADEMIC_NOTES_LIST_FAILED",
};

// ============================================ Actions ========================================================
export const academicNotesListStart = (data) => ({
    type: actionType.ACADEMIC_NOTES_LIST_START,
    payload: data,
});

export const academicNotesListSuccess = (data) => ({
    type: actionType.ACADEMIC_NOTES_LIST_SUCCESS,
    payload: data,
});

export const academicNotesListFailed = (data) => ({
    type: actionType.ACADEMIC_NOTES_LIST_FAILED,
    payload: data,
});

// =========================================== Reducer ===========================================================
const INIT_STATE = {
    loading: false,
    data: null,
    error: null,
};

export default function academicNotesListReducer(state = INIT_STATE, action) {
    switch (action.type) {
        case actionType.ACADEMIC_NOTES_LIST_START:
            return {
                ...state,
                loading: true,
            };
        case actionType.ACADEMIC_NOTES_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null,
            };
        case actionType.ACADEMIC_NOTES_LIST_FAILED:
            return {
                ...state,
                loading: false,
                data: null,
                error: action.payload,
            };
        default:
            return { ...state };
    }
}

// ===================================================== side effect =============================================

export function* academicNotesListSaga(action) {
    try {
        
        const response = yield fetchGraphMethod(action.payload.query, action.payload.variables, true);
        if (response && response.status === 200) {
            const allacademicNotes =  response.data.data.allAcademicnotes.Academicnotes
            yield put(academicNotesListSuccess(allacademicNotes));
        } else {
            messagePopup("", "academic Notes List failed", "error");
            yield put(academicNotesListFailed("academic Notes List failed"));
        }
    } catch (error) {
        messagePopup("", "academic Notes List failed", "error");
        yield put(academicNotesListFailed("academic Notes List failed"));
    }
}

export function* watchAcademicNotesListSaga() {
    yield takeEvery(actionType.ACADEMIC_NOTES_LIST_START, academicNotesListSaga);
}
